import { CSSProperties } from 'react';
import { getTaxonomyColor, useEntityIcon } from '@agilelab/plugin-wb-platform';
import { Box, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';

type EntityIconProps = {
  useCaseTemplateId: string;
  kind: string;
  title: string;
  taxonomyId?: string;
  style?: CSSProperties;
  className?: string;
};

const useStyles = makeStyles<Theme, { taxonomyId: string }>(
  theme => ({
    root: {
      width: '20px',
      height: '20px',
      overflow: 'hidden',
    },
    img: {
      width: '100%',
      height: '100%',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    taxonomyColor: props => ({
      color: getTaxonomyColor(props.taxonomyId, theme),
    }),
  }),
  { name: 'EntityIcon' },
);

export const EntityIcon = ({
  useCaseTemplateId,
  kind,
  title,
  taxonomyId,
  className,
  style,
}: EntityIconProps) => {
  const classes = useStyles({ taxonomyId: taxonomyId ?? '' });
  const { getIcon } = useEntityIcon();

  const icon = getIcon(useCaseTemplateId, kind);

  const getIconElement = () => {
    if (icon === undefined) return <></>;
    if (icon.type === 'img')
      return (
        <div
          className={classes.img}
          style={{ backgroundImage: `url(${icon.src})` }}
          role="img"
          aria-label={title}
        />
      );
    return (
      <div className={classes.img}>
        <icon.icon />
      </div>
    );
  };

  return (
    <Box
      className={clsx(classes.root, classes.taxonomyColor, className)}
      style={style}
    >
      {getIconElement()}
    </Box>
  );
};
